// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "大学物理（下)",
      "tec": "任婕",
      "week": "1-12,15-16周",
      "add": "教学楼C座110教务"
    },
    {
      "sub": "中国近现代史纲要",
      "tec": "果金凤",
      "week": "1-12周",
      "add": "教学楼A座117电力"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "王琪",
      "week": "1-12,15-18单周",
      "add": "教学楼C座110教务"
    },
    {
      "sub": "科技文献检索",
      "tec": "张岚",
      "week": "1-4周",
      "add": "教学楼A座117电力"
    },
    {
      "sub": "形势与政策",
      "tec": "单超",
      "week": "1-4周",
      "add": "教学楼C座114教务"
    }
  ],
  "2": [
    0,
    [
      {
        "sub": "大学英语（三）",
        "tec": "刘雪松",
        "week": "1-14周",
        "add": "实训楼E座503语音室"
      },
      {
        "sub": "25计理1-1",
        "tec": "文菲",
        "week": "1-14周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "25计理2-1",
        "tec": "娄小星",
        "week": "1-14周",
        "add": "教学楼A座123信息"
      },
      {
        "sub": "25计理1-3",
        "tec": "曹东波",
        "week": "1-14周",
        "add": "教学楼A座125信息"
      }
    ],
    {
      "sub": "数据结构与算法",
      "tec": "曹福毅",
      "week": "1-12,15-18单周",
      "add": "教学楼B座218自控"
    },
    {
      "sub": "电路（二）",
      "tec": "申爱兵",
      "week": "1-12,15-18周",
      "add": "实训楼F座201自控"
    },
    0
  ],
  "3": [
    {
      "sub": "电子技术基础",
      "tec": "秦宏",
      "week": "1,4-12,15-18周",
      "add": "教学楼A座119信息"
    },
    {
      "sub": "就业创业指导",
      "tec": "毛伟伟",
      "week": "1-5周",
      "add": "教学楼C座114教务"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "数据结构与算法",
      "tec": "曹福毅",
      "week": "1-12,15-18周",
      "add": "教学楼B座224自控"
    },
    {
      "sub": "大学物理（下)",
      "tec": "任婕",
      "week": "1-12,15-16周",
      "add": "实训楼F座102自控"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "傅瑶",
      "week": "1-12,15-18周",
      "add": "实训楼F座102自控"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "樊绍斌",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "郝策",
        "week": "1-12,14-18周",
        "add": "男乒"
      },
      {
        "sub": "男网",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "搏击",
        "tec": "陈迪",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女乒",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "足球",
        "tec": "李莉",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "女羽",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "男篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "男乒"
      },
      {
        "sub": "健美操",
        "tec": "李灏",
        "week": "1-18周",
        "add": "男乒"
      }
    ],
    {
      "sub": "电路（二）",
      "tec": "申爱兵",
      "week": "1-12,15-18单周",
      "add": "实训楼F座201自控"
    }
  ],
  "5": [
    {
      "sub": "中国近现代史纲要",
      "tec": "果金凤",
      "week": "1-12周",
      "add": "教学楼A座116电力"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "王琪",
      "week": "1-12,15-18周",
      "add": "实训楼F座103自控"
    },
    [
      {
        "sub": "大学英语（三）",
        "tec": "文菲",
        "week": "1-14周",
        "add": "教学楼A座123信息"
      },
      {
        "sub": "25计理2-1",
        "tec": "刘雪松",
        "week": "1-14周",
        "add": "教学楼A座119信息"
      },
      {
        "sub": "25计理1-1",
        "tec": "娄小星",
        "week": "1-14周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "25计理1-3",
        "tec": "曹东波",
        "week": "1-14周",
        "add": "实训楼E座503语音室"
      }
    ],
    {
      "sub": "电子技术基础",
      "tec": "秦宏",
      "week": "1,4-12,15-18单周",
      "add": "实训楼F座203自控"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
